export const exportSquadJson = (data) => {
  try {
    // 1. 데이터 문자열화 (들여쓰기 2칸으로 가독성 확보)
    const blob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });

    // 2. 파일명에 날짜 포함 (예: backup-2024-05-20.json)
    const date = new Date().toISOString().split('T')[0];
    const fileName = `kbo-squadmaker-backup-${date}.json`;

    // 3. 다운로드 링크 생성 및 클릭
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    
    document.body.appendChild(link);
    link.click();

    // 4. 정리 (메모리 누수 방지)
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    console.log("백업이 성공적으로 완료되었습니다.");
  } catch (error) {
    console.error("백업 중 오류 발생:", error);
  }
};